/*
 * @Author: Lim 
 * @Date: 2020-09-10 17:24:16 
 * @Last Modified by: Lim
 * @Last Modified time: 2020-09-17 14:26:38
 */
import React, { useState, useEffect, useRef } from 'react';
import style from "./Modal.module.scss";
import cn from 'classnames'
import { initConfig, unitFilter } from '../common';


export default (props) => {
    /**
     * default
     */
    const defaultConfig = {
        show: false,
        title: '温馨提示',
        titleBar: true,
        width: '380',
        top: '50%',
        left: '50%',
        iconPoint: 'feedbackWarning',
        iconFontColor: '#FFAA00',
        iconFontSize: '16',
        closeShow: true,
        closemodal(){}
    }
    /**
     * initial
     * 数据对比
     * 单位过滤
     */
    const { 
        show,
        title,
        titleBar,
        width,
        top,
        left,
        iconPoint,
        iconFontColor,
        iconFontSize,
        closeShow,
        closemodal
    } = initConfig( defaultConfig, props.config );

    const defaultWidth = unitFilter ( width );
    const defaultTop = unitFilter ( top );
    const defaultLeft = unitFilter ( left );
    const defaultIconFontSize = unitFilter ( iconFontSize );
    /**
     * state
     * 模态框显示 & 隐藏
     */
    const [ isShow, setIsShow ] = useState(false);
    /**
     * didmount & update & unMount
     * update
     */
    useEffect(() =>{
        setIsShow( show )
    },[ show ])
    /**
     * DOM
     */
    let children = null;
    if( Boolean( props.children instanceof Array) === false ){
        children = [ props.children ];
    }else{ 
        children = props.children;
    }
    return (
        <div>
            {
                isShow === false ? "" :
                <div className={ style.main }>
                    <div className={ style.masking }>
                        <div 
                            className={ style.modal }
                            style={{ 
                                width: defaultWidth,
                                top: defaultTop,
                                left: defaultLeft,
                            }}
                        >
                            {
                                titleBar ? 
                                <div className={ style.header }>
                                    <span className={ style.title }>{ title }</span>
                                    {
                                        closeShow ===  false ? "" :
                                        <div className={ style.close } onClick={ ()=> closemodal() }>
                                            <span className={ cn( style.icon_close, 'font_family','icon-close') }></span> 
                                        </div>
                                    }
                                </div>: ""
                            }
                            <div className={ style.body }>
                                {
                                    iconPoint === "" ? "" :
                                    <div 
                                        className={ style.icon_point }
                                        style={{ color: iconFontColor }}
                                    >
                                        <span className={ cn('icon','font_family','icon-'+ iconPoint ) } style={{ fontSize: defaultIconFontSize }}></span>
                                    </div>
                                }
                                <div className={ style.content }>
                                    { children[0] }
                                </div>
                            </div>
                            {
                                children[1] ? 
                                <div className={ style.footer }>
                                    { children[1] }
                                </div>:""
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    )
    
}